// extracted by mini-css-extract-plugin
module.exports = {"squareHolder":"buttonloading_squareHolder__1M9aC","square":"buttonloading_square__w0eFG","loading":"buttonloading_loading__1nbSB"};